define("shared/utils/analytics/generate-cache-key", ["exports", "shared/utils/hash-code"], function (_exports, _hashCode) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = generateCacheKey;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/hash-code"eaimeta@70e063a35619d71f
  /**
   * Returns a string with a prefix and unique hashed value to be used for caching. To be used with api endpoints.
   * @param prefix start of string that is to be used for lookup from cache
   * @param cacheParams
   */

  function generateCacheKey(prefix, _ref) {
    let {
      dateKey = null,
      type = 'data',
      endpoint,
      mediaId = null,
      socialProfileId = undefined,
      cursor = null,
      linkinbioPostId = undefined,
      linkinbioPageId = undefined,
      tagIds = undefined
    } = _ref;
    return `${prefix}_${(0, _hashCode.default)(JSON.stringify({
      dataType: type,
      dateKey,
      endpoint,
      mediaId,
      socialProfileId,
      cursor,
      linkinbioPostId,
      linkinbioPageId,
      tagIds
    }))}`;
  }
});